/**
 * Badge vermelho do item "Chats" na sidebar: total de mensagens não lidas da
 * aba Entrada (polling 30s), no mesmo estilo do sino de notificações.
 * Renderiza null quando não há não lidas.
 */
import { useQuery } from '@tanstack/react-query';
import { cn } from '@/lib/utils';
import { useRealtimeConnected } from '@/lib/realtime';
import { chatsListOptions } from './chats-queries';

export function ChatsNavBadge({ collapsed }: { collapsed?: boolean }) {
  // SSE conectado ⇒ eventos de chat invalidam a família 'list' (inclui esta
  // query); o polling vira fallback lento.
  const realtimeUp = useRealtimeConnected();
  const listQ = useQuery({
    ...chatsListOptions({ tab: 'inbox' }),
    refetchInterval: realtimeUp ? 120_000 : 30_000,
    staleTime: 25_000,
  });

  const total = (listQ.data ?? []).reduce((sum, chat) => sum + chat.unreadCount, 0);
  if (total === 0) return null;

  return (
    <span
      aria-label={`${total} mensagens não lidas`}
      className={cn(
        'flex h-4 min-w-4 items-center justify-center rounded-full bg-destructive px-1 text-[10px] leading-none font-semibold text-white',
        collapsed ? 'absolute top-1.5 right-1.5' : 'ml-auto'
      )}
    >
      {total > 99 ? '99+' : total}
    </span>
  );
}
